module.exports = __webpack_public_path__ + "img/sumMoney.2a881414.png";